
import AuroraBackground from '~/components/common/aurora-background.vue'
import PageBottom from '~/components/common/page-bottom/index.vue'
import TextPressure from '~/components/common/text-pressure.vue'
import FooterNew from '~/components/FooterNew.vue'
import TextPressureMixin from '~/mixins/text-pressure.vue'
import VisionKv from '~/sections/vision/kv.vue'
import VisionProgram from '~/sections/vision/program.vue'
import VisionStrategy from '~/sections/vision/strategy.vue'

export default {
  components: {
    TextPressure,
    VisionKv,
    VisionStrategy,
    VisionProgram,
    PageBottom,
    FooterNew,
    AuroraBackground
  },
  mixins: [TextPressureMixin],
  layout: 'home',
  head() {
    const title = 'VISION'
    const extendMeta = this.$helper.setMetaTitleAndDescription(title)

    return {
      title,
      meta: [...extendMeta]
    }
  }
}
